var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDustbin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fill 1437 + Fill 1438"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1437",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.10526V0H6V2.10526H0V4.21053H18V2.10526H12Z",
    fill: "#228EC2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 1438",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.7895H10V9.47369H12V15.7895ZM8 15.7895H6V9.47369H8V15.7895ZM2 5.26316V17.8947C2 19.0558 2.897 20 4 20H14C15.103 20 16 19.0558 16 17.8947V5.26316H2Z",
    fill: "#228EC2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDustbin);
export default __webpack_public_path__ + "static/media/dustbin.b35366f01fcb6e743c491525b2edbd64.svg";
export { ForwardRef as ReactComponent };